import { ButtonPosition } from '@/common/manager/position/button-position';
import { getRealizeValue } from '@/common/util/util';
export const config = {
    value: 'reset',
    position: [ButtonPosition.formDialog, ButtonPosition.form],
    action: (config) => {
        const { buttonConfig, formInstance } = config;
        const realFormInstance = getRealizeValue(formInstance);
        if (buttonConfig && realFormInstance) {
            realFormInstance.reset('*');
        }
    },
};
